const tabsConfig = [
	{ name: 'software', displayText: 'software_change_summary' },
	{ name: 'pairing', displayText: 'pairing_history' },
	{ name: 'connection', displayText: 'connection_history' },
	{ name: 'ErrorRecall', displayText: 'Error history ' },
];

export default tabsConfig;
